import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useShop } from '@/contexts/ShopContext';
import { usePermissions } from '@/hooks/usePermissions';
import { Sidebar as DashboardV3Sidebar, MobileRailDrawer } from '@/components/dashboard-v3/sidebar';
import { SubNavProvider } from '@/contexts/SubNavContext';

export default function PosLayout() {
  const { t } = useTranslation('pos');
  const { currentShop } = useShop();
  const { isOwnerOrManager } = usePermissions();

  const shopName = currentShop?.name ?? '';

  return (
    <TooltipProvider>
      <SubNavProvider>
        <div data-app-shell="pos" className="flex h-dvh bg-[#F7F7F8] dark:bg-background">
          {/* Rail 88px (icon + label) — desktop only, same component as /owner/* */}
          <DashboardV3Sidebar />

          {/* Mobile drawer (2-pane HeyGen-style) — burger top-left */}
          <MobileRailDrawer />

          {/* Main column */}
          <div className="flex min-w-0 flex-1 flex-col">
            <header className="border-border flex shrink-0 items-center gap-3 border-b px-4 pb-2 pl-20 pt-[calc(env(safe-area-inset-top,0px)+0.5rem)] lg:pl-4">
              <span className="text-sm font-semibold">{shopName}</span>
              {isOwnerOrManager && (
                <span
                  aria-label="Mode propriétaire"
                  className="inline-flex items-center rounded-sm border border-charcoal-950 bg-lime-500 px-1.5 py-0.5 font-mono text-[9.5px] font-bold uppercase tracking-[0.08em] text-charcoal-950"
                >
                  Prop
                </span>
              )}
              <span className="text-muted-foreground ml-auto text-xs">{t('title')}</span>
            </header>
            <main className="flex-1 overflow-hidden">
              <Outlet />
            </main>
          </div>
        </div>
      </SubNavProvider>
    </TooltipProvider>
  );
}
